import { DeckValue } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';

export interface GlycemicControl extends DeckValue {
  cpoeSequence: number,
  doseQuantity: number,
  glycemicProtocolSequence: number,
  internalProcedureSequence: number,
  intervalCode: string,
  intervalDescription: string,
  pdoPrn: boolean,
  isProcessStatus: string,
  itemDescription: string,
  materialDescription: string,
  observationDescription: string,
  prescriptionDescription: string,
  prescriptionNumber: number,
  prescriptionValidate: string,
  procedureCode: number,
  processSequence: string,
  processes?: GlycemicProcess[],
  protocolDescription: string,
  scheduleDate: string,
  scheduleSequenceNumber: number,
  sequenceProcedure: number,
  statusSchedule: string,
  statusSuspension: string,
  suspensionDate: string,
}

export interface GlycemicReschedule extends Record<string, Value>{
  consistRescheduleItemTime: string;
  currentTime: string;
  desiredTime: string;
  eliminatedList?: string;
  encounterNumber: number;
  errorDescription?: string;
  establishmentCode: string;
  internalProcedureNumber: number;
  intervalCode: string;
  itemCode: number;
  itemQuantity: number;
  itemSequence: number;
  itemType: string;
  justificationDescription: string;
  laboratoryStatus: string;
  prescriptionId?: string;
  prescriptionsIds: string;
  reasonNumber: number;
  scheduleTime: string;
  userName: string;
}

export interface ScheduleTimeItemPrescriptionRequest extends GlycemicReschedule {
  functionCode: number;
  observationDescription: string;
  scheduleItemCicleStatus: 'N' | 'S';
  scheduleSequenceNumber: number;
  statusAcm: string;
  statusApplication: string;
  unitMeasurementCode?: string;
}

export interface GlycemicMedicationResponse {
  administer: boolean;
  conferences: GlycemicMedicationConference[];
  generatedSupplementaryMedicine: boolean;
  itemsToConference: GlycemicMedicationConference[];
  onlyOrientation: boolean;
  orientation: string;
  releasePharmacy: boolean;
  requestLabel: boolean;
}

export interface GlycemicMedicationConference extends Record<string, Value>{
  doseQuantity: number;
  materialDescription: string;
  materialSequenceNumber: number;
  prescriptionNumber: number;
  schedulesDescription: string;
  sequenceMaterialSchedule: number;
  unitMeasureDoseCodeDescription: string;
}

export enum RequiredFieldParam78 {
  JUSTIFICATION = 'J',
  REASON = 'M',
  BOTH = 'A',
  NONE = 'N'
}

export enum GlycemicProcessStatus {
  PREPARED = 'P',
  GENERATED = 'G' ,
}

export interface GlycemicQuestion {
  isAnswer: string;
  isPreviousAnswer: string;
  orientationDescription?: string;
  quantityMinutesSchedule?: number,
  questionDescription: string;
  questionSequence: number;
}

export interface GlycemicProcess {
  isProcessStatus: GlycemicProcessStatus;
  materialSequence: number;
  processSequence: number;
  scheduleSequenceNumber: number;
  sequenceProcedure: number;
}
export enum PerformType {
  PROCESS = 'P',
  HOUR = 'H'
}

export interface IntensiveGlycemicResponse {
  suggestion: string;
}

export interface IntensiveGlycemicMeasurementResponse {
  amount: number;
  registered: boolean;
  suggestion: string;
}

export interface Variation {
  id: string;
  variation: string;
}

export interface GlycemicRegistrationLevel {
  glycemicQuantity: number;
  suggestionDescription: string;
  variation: string;
}

export interface ResponseBodyProps {
  hourDate?: string;
  informDose?: boolean;
  materialCode?: number;
  message?: string;
  messageType: string;
  read?: boolean;
  remainingDoseQuantity?: number;
  success?: boolean;
  total?: number;
  totalRead?: number;
}

export interface ApplicationSite {
  code: string;
  description: string;
  sequencePriority: number;
}

export interface ApplicationSiteRequest extends Record<string, Value> {
  applicationSiteCode: string;
  prescriptionNumber: number,
  scheduleSequenceNumber: number;
}